<template>
    <div class="index-branch-item" :style="[{'margin-top': widthScale * item.marginTop + 'px' || 0},{'margin-bottom': widthScale * item.marginBottom + 'px' || 0},{'background-image': 'url(' + getStyle('bgImageUrl', branch) +')'}]">
        <div class="index-branch-head">
            <div class="left">
                <div class="pic-1" :style="{'background-color': item.branchAndGoodsStyle.hideLogo != 1 || isb('branchAndGoodsStyle', 'logoImageUrl') ? '':'transparent'}">
                    <van-image v-if="item.branchAndGoodsStyle.hideLogo != 1" :src="isb('branchAndGoodsStyle','logoImageUrl') || isb('branch','logoImageUrl') || isb('brandLogo', 'logoImageKeyUrl')"></van-image>
                </div>
                <span class="t1" v-if="item.branchAndGoodsStyle.hideBranchName != 1" :style="{'color': getStyle('branchNameColor', branch)}">{{isb('branchAndGoodsStyle', 'branchAliasName') || isb('branch','branchName') || isb('brandLogo','brandName')}}</span>
                <!-- <img class="icon" src="../../assets/image/arrow_icon_white@2x.png" /> -->
                <!-- <span class="icon"></span> -->
            </div>
            <van-button  class="btn-1" :data-growing-title="branch.branchLogoName" @click="onJumpToBranch(branch.branchId||branch.refId)" :style="{'background-color': getStyle('enterBranchButtonColor', branch),'color': getStyle('enterBranchFontColor', branch), 'background-image': isb('branchAndGoodsStyle','enterBranchType') == 2 ? 'url('+isb('branchAndGoodsStyle','enterBranchButtonImageUrl')+')': ''}">{{isb('branchAndGoodsStyle','enterBranchType') == 2?'':item.type==4?'进入店铺':'进入品牌'}}</van-button>
        </div>
        <div class="index-branch-main">
            <div class="index-branch-container">
                <div class="index-branch-goods" v-for="(goods, index) in goodsList" :key="index">
                    <div class="index-branch-content" :data-growing-title="goods.title">
                        <div class="index-branch-img-box pic-2">
                          <img v-if="goods.type=='DISCOVER'" class="index-branch-logo" src="../../assets/brand/new-wenwen.png"/>
                          <img class="pic-2" @click="onJumpToOther(goods, index)" fit="cover" :src="goods.indexImage.imageUrl + '?x-oss-process=style/style_indexshop_img'" />
                        </div>
                        <p class="index-branch-price">
                            <span class="price-1" :style="{'color': getStyle('goodsPriceColor', branch)}">￥{{goods.price}}</span>
                            <span class="price-2" :style="{'color': getStyle('goodsMarkPriceColor', branch)}">￥{{goods.markingPrice}}</span>
                        </p>
                        <div class="btn-2" :style="{'background-color': getStyle('discountBottomBoxColor', branch),'color': getStyle('discountFontColor', branch)}">
                            <p>{{funPrice(goods)}}</p>
                        </div>
                    </div>
                </div>
                <div class="index-branch-goods index-branch-more" @click="onJumpToBranch(branch.branchId||branch.refId)">
                    <!-- <img src="../../assets/image/find_more.png" /> -->
                    <div>
                      <img src="@/assets/brand/branch-more.png" alt="">
                      <div class="more">查看更多</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/utils/axios";
import utils from '@/utils/common';
import { isWeChatApplet } from "@/utils/util";
export default {
    props: {
        contentPageId: {
            default: 0,
            type: [Number, String]
        },
        item: {
            type: Object,
            default: function() {
                return {}
            }
        },
        branch: {
            type: Object,
            default: function() {
                return {}
            }
        },
        goodsList: {
            type: Array,
            default: function() {
                return []
            }
        },
        row: {
            type: Number,
            default: 0
        },
        sort: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            widthScale:  window.innerWidth / 750,
        }
    },
    mounted() {
        gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'店铺+混排推荐', entryType_floor_var: this.item.sort+'---'+this.branch.sort, entryType_row_position_var: String(this.row)});
    },
    methods: {
        async onJumpToBranch(id) {
            if(this.item.type == 4) {
                if(await isWeChatApplet()) {
                     utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/brandindex?id=' + id,
                        noTitle: '1',
                         action:{tm:"4090100",tp:{branchId:parseInt(id)}}
                    });
                } else {
                    wx.miniProgram.navigateTo({url: '/product/pages/store-detail/index?storeid=' + id})
                }
            } else {
                if(await isWeChatApplet()) {
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/brandlist?id=' + id,
                        noTitle: '1',
                        barColor: "#FFFFFF"
                    });
                } else {
                    wx.miniProgram.navigateTo({url: '/product/pages/new-store-list/index?storeid=' + id})
                }
            }
            if(await isWeChatApplet()) {
                utils.nativeMethod({tm:'4000101',tp:{module_evar: '店铺+混排推荐'}})
            }
        },
        async onJumpToOther(item, index) {
            gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:this.item.title+'---'+this.branch.branchLogoName, entryType_floor_var: this.item.sort+'---'+this.branch.sort, position_var:String(index), sort_var:'', positonName_var:String(item.itemName || item.id), entryType_row_position_var: String(this.row)});
            switch(item.type) {
                case 'PRODUCT': 
                    if(await isWeChatApplet()) {
                        // this.$router.push({
                        //     path: "/commoditydetails",
                        //     query: { id: item.refId }
                        // });
                        var obj = {goodsId:parseInt(item.refId)};
                    utils.jumpToNewPage({
                        url: window.location.origin + "/h5user/commoditydetails?id=" + item.refId,
                        noTitle: "0",
                        action:{tm:"4030100",tp:obj}
                    });

                    } else {
                        wx.miniProgram.navigateTo({url: '/product/pages/product-detail/index?productid=' + item.refId})
                    }
                    break;
                case 'DISCOVER':
                    if(await isWeChatApplet()) {
                        this.$router.push({
                            name: 'discoverUserDetails', 
                            query: { discoverId: item.refId }
                        })
                    } else {
                        wx.miniProgram.navigateTo({url: '/other/pages/find-details/index?discoverId=' + item.refId})
                    }
                    break;
            }
            if(await isWeChatApplet()) {
                utils.nativeMethod({tm:'4000101',tp:{module_evar: '店铺+混排推荐'}})
            }
        },
        getStyle(key, branch) {
            if(branch.branchAndGoodsStyle&&branch.branchAndGoodsStyle[key]) {
                return branch.branchAndGoodsStyle[key]
            } else {
                return this.item.branchAndGoodsStyle[key]
            }
        },
        isb(key, value) {
            let val = this.branch[key] && this.branch[key][value]
            if( value =='logoImageUrl' || value =='logoImageKeyUrl'){
                return val ? val+'?x-oss-process=style/style_index_brandlogo':val
            }
            return val
        },
        funPrice(item) {
            if (item.price == item.markingPrice) {
                return "暂无折扣";
            } else {
                var str = (item.price / item.markingPrice * 10).toFixed(1);
                return "低至" + str + "折";
            }
        },
        getBranchRecommend() {
            http({
                url: '/search/es/branch/recommend',
                method: 'post',
                parmes: {
                    branchId: this.branch.branchId
                }
            }).then(rps=>{
                if(rps.code == 200) {
                    this.$loading.hide()
                    this.goodsList = rps.data.data
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.index-branch-item {
    height: 374px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .index-branch-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        height: 84px;
        box-sizing: border-box;
        .left {
            display: flex;
            align-items: center;
            .pic-1 {
                display: flex;
                width: 92px;
                height: 64px;
                padding: 8px;
                box-sizing: border-box;
                border-radius: 6px;
                img {
                    vertical-align: bottom;
                }
            }
            .t1 {
                max-width: 360px;
                font-size: 24px;
                font-weight: 500;
                color: #fff;
                margin: 0 10px 0 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .icon {
                width: 40px;
                height: 40px;
            }
        }
    }
    .index-branch-main {
        height: 270px;
        padding: 0 15px;
        margin-top: 10px;
    }
    .index-branch-container {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        &::-webkit-scrollbar {display:none}
    }
    .index-branch-goods.index-branch-more {
        padding: 0;
        flex: none;
        overflow: hidden;
        width: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        >div{
          font-size: 28px;
        }
        img {
            width: 48px;
            height: 48px;
            vertical-align: top;
        }
        .more {
          margin-top: 16px;
          width: 48px;
          font-size: 20px;
          text-align: center;
          line-height: 28px;
          color: #CCCCCC;
        }
    }
    .index-branch-goods {
        width: 180px;
        height: 270px;
        // flex-shrink: 0;
        box-sizing: border-box;
        margin-left: 10px;
        background-color: #fff;
        border-radius: 10px;

        .index-branch-content {
            position: relative;
            padding: 10px 10px 0;
        }

        &:first-child {
            margin-left: 0;
        }
        .index-branch-img-box {
            position: relative;
            overflow: hidden;
        }
        .pic-2 {
            width: 160px;
            height: 160px;
            vertical-align: bottom;
        }
        .index-branch-logo {
            width: 57px;
            height: 30px;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 5;
        }
        .index-branch-price {
            height: 33px;
            line-height: 33px;
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin-bottom: 7px;
        }
    }
    .btn-1 {
        width: 120px;
        height: 40px;
        color: red;
        border-radius: 20px;
        padding: 0;
        font-size: 20px;
        font-weight:500;
        border: none;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .btn-2 {
        width: 160px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 17px;
        font-size: 20px;
        font-weight:500;
        background-color: #fd9090;
        padding-top: 3px;
        box-sizing: border-box;

        p {
            display: inline-block;
            line-height: 33px;
            text-align: center;
        }
    }
    .price-1 {
        font-size: 24px;
        color: #E83636;
        font-weight: 500;
    }
    .price-2 {
        font-size: 20px;
        color: #ccc;
        font-weight: 400;
        margin-left: 10px;
        text-decoration: line-through;
    }
}
</style>